export default __webpack_public_path__ + "static/media/login.0fe1e53c.jpg";